import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight, BookOpen } from 'lucide-react';
const slides = [{
  src: 'https://cdn.magicpatterns.com/uploads/jk5obuUNXbzMuN2ka5cpxt/IMG_4731.png',
  alt: 'Distribución semanal tipo: 6 horas exactas'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/eJz9sy2WQcAMarq2qBky8k/IMG_4732.png',
  alt: 'Plantilla semanal Fase 2 (Intensidad)'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/i2XhXqUkf7YhRgECbcYtVP/IMG_4733.png',
  alt: 'Resumen visual del sistema'
}];
export function EbookCarousel() {
  const [index, setIndex] = useState(0);
  const [direction, setDirection] = useState(0);
  const go = (newIndex: number) => {
    setDirection(newIndex > index ? 1 : -1);
    setIndex((newIndex + slides.length) % slides.length);
  };
  return <div className="w-full max-w-2xl mx-auto mt-12" data-id="element-162">
      <div className="text-center mb-4" data-id="element-163">
        <span className="inline-flex items-center gap-2 px-3 py-1 bg-brand-green/15 text-brand-green text-xs font-bold tracking-wider uppercase rounded-full" data-id="element-164">
          <BookOpen size={12} data-id="element-165" />
          Vista previa del ebook
        </span>
      </div>

      <div className="relative bg-white rounded-2xl overflow-hidden border border-white/10 shadow-2xl shadow-brand-green/10" data-id="element-166">
        {/* Slide */}
        <div className="relative aspect-[16/10] overflow-hidden bg-slate-100" data-id="element-167">
          <AnimatePresence initial={false} custom={direction} mode="wait" data-id="element-168">
            <motion.img key={index} src={slides[index].src} alt={slides[index].alt} custom={direction} initial={{
            opacity: 0,
            x: direction * 40
          }} animate={{
            opacity: 1,
            x: 0
          }} exit={{
            opacity: 0,
            x: direction * -40
          }} transition={{
            duration: 0.35,
            ease: 'easeOut'
          }} className="absolute inset-0 w-full h-full object-cover" data-id="element-169" />
          </AnimatePresence>

          {/* Arrows */}
          <button onClick={() => go(index - 1)} aria-label="Anterior" className="absolute left-2 top-1/2 -translate-y-1/2 w-9 h-9 rounded-full bg-black/60 hover:bg-black/80 text-white flex items-center justify-center backdrop-blur-sm transition-colors" data-id="element-170">
            <ChevronLeft size={18} data-id="element-171" />
          </button>
          <button onClick={() => go(index + 1)} aria-label="Siguiente" className="absolute right-2 top-1/2 -translate-y-1/2 w-9 h-9 rounded-full bg-black/60 hover:bg-black/80 text-white flex items-center justify-center backdrop-blur-sm transition-colors" data-id="element-172">
            <ChevronRight size={18} data-id="element-173" />
          </button>

          {/* Counter (IG-style) */}
          <div className="absolute top-3 right-3 bg-black/60 text-white text-xs font-medium px-2.5 py-1 rounded-full backdrop-blur-sm" data-id="element-174">
            {index + 1} / {slides.length}
          </div>
        </div>
      </div>

      {/* Dots */}
      <div className="flex items-center justify-center gap-2 mt-4" data-id="element-175">
        {slides.map((_, i) => <button key={i} onClick={() => go(i)} aria-label={`Ir a la imagen ${i + 1}`} className={`h-1.5 rounded-full transition-all ${i === index ? 'w-6 bg-brand-green' : 'w-1.5 bg-white/30 hover:bg-white/50'}`} data-id="element-176" />)}
      </div>
    </div>;
}